import { FormControl, FormLabel, Textarea, TextareaProps as ChakraTextareaProps } from "@chakra-ui/react";
interface TextAreaProps extends ChakraTextareaProps {
    errors?: any;
    register?: any;
    label?: string;
    labelColor?: string;
    name?: string;
    variant?: string;
}
export function TextArea({ 
    labelColor,
    label,
    children,
    className,
    register,
    errors,
    name,
    variant = "outline",
    ...rest
}: TextAreaProps) {
    return(
        <FormControl isInvalid={!!errors?.message}>
            {label && (
                <FormLabel
                    w="100%"
                    color={labelColor ? labelColor : "gray.400"}
                    fontSize="12px"
                >
                    {label}
                </FormLabel>
            )}
            <Textarea 
                {...rest}
                {...register}
                name={name}
                borderRadius="2px"
            />
        </FormControl>
        
    )
}